/**
 * Berndorf „Mehr anzeigen"
 *
 * Hängt die nächste Seite an das Produktraster an, statt zu blättern.
 *
 * Der Klick wird DELEGIERT am document abgefangen und nicht beim Laden an den
 * Link gebunden: facets.js ersetzt bei jedem Filterklick das komplette
 * `innerHTML` von #ProductGridContainer und feuert dabei kein
 * `shopify:section:load`. Eine direkte Bindung wäre nach dem ersten Filter tot.
 *
 * Ohne JavaScript bleibt der Link ein normaler Link auf ?page=N.
 */
(function () {
  var BUSY = 'is-loading';

  function segments() {
    var container = document.getElementById('ProductGridContainer');
    return container ? container.querySelectorAll('ul.product-grid') : [];
  }

  /* Angehängt wird immer an das LETZTE Raster: davor können randlose Bänder
     liegen, die das Raster in mehrere Listen zerschneiden. */
  function lastGrid() {
    var all = segments();
    return all.length ? all[all.length - 1] : null;
  }

  function sectionId() {
    var first = document.getElementById('product-grid');
    return first ? first.dataset.id : null;
  }

  /* Über alle Abschnitte zählen — das Raster ist durch die Bänder zerschnitten.
     Die Editorial-Kachel ist zwar eine Rasterzelle, aber kein Produkt. */
  function allLoadedCount() {
    var total = 0;
    Array.prototype.forEach.call(segments(), function (grid) {
      total += grid.querySelectorAll(':scope > li:not(.berndorf-collection-standard-listing__item--tile)').length;
    });
    return total;
  }

  /* Eigene Live-Region statt der Trefferzahl: die pflegt facets.js, und ein
     zweiter Schreiber darauf würde die Filtermeldung überschreiben. */
  function announce(added, total) {
    var status = document.querySelector('[data-berndorf-load-more-status]');
    if (!status) return;
    status.textContent =
      added + ' weitere ' + (added === 1 ? 'Produkt' : 'Produkte') + ' geladen, ' + total + ' insgesamt sichtbar.';
  }

  function load(link) {
    var target = lastGrid();
    var id = sectionId();
    if (!target || !id) return;

    var wrapper = link.closest('.berndorf-load-more');
    var url = new URL(link.href, window.location.origin);
    url.searchParams.set('section_id', id);

    link.classList.add(BUSY);
    link.setAttribute('aria-busy', 'true');

    fetch(url.toString())
      .then(function (response) {
        if (!response.ok) throw new Error('HTTP ' + response.status);
        return response.text();
      })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var grids = doc.querySelectorAll('ul.product-grid');
        var fetched = grids.length ? grids[grids.length - 1] : null;
        if (!fetched) throw new Error('Kein Raster in der Antwort');

        var added = Array.prototype.slice.call(fetched.children);
        added.forEach(function (item) {
          target.appendChild(item);
        });

        /* Den Link-Container durch den der Folgeseite ersetzen; fehlt er dort,
           war das die letzte Seite. */
        var nextWrapper = doc.querySelector('.berndorf-load-more');
        if (nextWrapper && wrapper) {
          wrapper.replaceWith(nextWrapper);
        } else if (wrapper) {
          wrapper.remove();
        }

        announce(added.length, allLoadedCount());

        /* Fokus auf die erste neue Karte, sonst landet er nach dem Ersetzen
           des Links am Seitenanfang. */
        var focusTarget = added.length ? added[0].querySelector('a, button') : null;
        if (focusTarget) {
          focusTarget.setAttribute('tabindex', '-1');
          focusTarget.focus({ preventScroll: true });
        }
      })
      .catch(function () {
        /* Nachladen fehlgeschlagen — der Link bleibt stehen und führt beim
           nächsten Klick regulär auf die Folgeseite. */
        link.classList.remove(BUSY);
        link.removeAttribute('aria-busy');
        link.removeAttribute('data-berndorf-load-more');
      });
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-berndorf-load-more]');
    if (!link) return;
    if (link.classList.contains(BUSY)) {
      event.preventDefault();
      return;
    }
    event.preventDefault();
    load(link);
  });
})();
